<template>
  <div
    v-show="progress"
    class="fill-width"
  >
    <h4 v-show="showCaption===true">
      {{ progress?progress.caption:"" }}
    </h4>
    <span v-show="progress.startDate">started:
      <SogDataLabel
        :value="progress.startDate"
        :value-type="SogDataLabelValueType.DateTime"
      /><br></span>
    <span v-show="progress.finishDate">finished:
      <SogDataLabel
        :value="progress.finishDate"
        :value-type="SogDataLabelValueType.DateTime"
      /><br></span>
    <div
      v-show="progress&&progress.resultMessage"
      :class="resultClass"
    >
      {{ progress?format(progress.resultMessage):"" }}<br>
    </div>
    <div v-show="progress&&progress.text">
      {{ progress?progress.text:"" }}<br>
    </div>
    <SogProgressBar
      v-show="progress&&progress.maxProgress>0&&!progress.finishDate"
      :model-value="value"
      height="25"
    >
      <strong>{{ progress?progress.statusText:"" }}</strong>
    </SogProgressBar>
    <SogProgressBar
      v-show="progress.finishDate!==undefined&&(!progress.finishDate)"
      :indeterminate="true"
    />
  </div>
</template>

<script setup lang="ts">
import {emptyProgressInfo, ProgressInfo} from "@/shared/model/ProgressInfo";
import {ref, watch} from "vue";
import {computed} from "vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";
import SogProgressBar from "@/shared/ui/SogProgressBar.vue";

interface Props {
  progressInfo?: ProgressInfo
  showCaption?: boolean
}

const _props = withDefaults(defineProps<Props>(), {progressInfo: undefined, showCaption: true}
)

const progress = ref(emptyProgressInfo)

watch(_props, () => {
    if (_props.progressInfo) {
      progress.value = _props.progressInfo
    } else {
      progress.value = emptyProgressInfo
    }
  }
)

function format(s: string) {
  if (s) {
    return s.replaceAll('/r/n', '<br>')
  }
}

const value = computed(() => {
  return progress.value && progress.value.progress
    ? Math.ceil(100 * progress.value.progress / (progress.value.maxProgress ? progress.value.maxProgress : 1)) : 0
})


const resultClass = computed(() => {
  return progress.value && progress.value.successful ? 'e-success' : 'e-error'
})


</script>

<style scoped>

</style>
